import { Button, ButtonOwnProps } from "@mui/material";
import { TbChecks } from "react-icons/tb";

import { useGetUnreadCount, useMarkAllNotificationsAsRead } from "@/requests/notification.queries";

/**
 * Header component for notification lists with title and mark-all-as-read button.
 */
function NotificationHeader() {
    return (
        <div className="flex sticky top-0 z-10 bg-white justify-between items-center py-2 px-3">
            <div className=" flex items-center text-lg text-gray-700 font-semibold gap-1">Bildirimler</div>
            <ReadAllNotificationButton />
        </div>
    );
}

/**
 * Reusable button component to mark all notifications as read.
 * Shows only when there are unread notifications.
 */
export function ReadAllNotificationButton({
    variant = "text",
    size = "small",
}: {
    variant?: ButtonOwnProps["variant"];
    size?: ButtonOwnProps["size"];
}) {
    const { data: unReadCountRes } = useGetUnreadCount();
    const { mutate: markAllNotificationsAsRead, isPending: markAllLoading } = useMarkAllNotificationsAsRead();
    return (
        (unReadCountRes && unReadCountRes.count && unReadCountRes.count > 0 && (
            <Button
                onClick={() => markAllNotificationsAsRead()}
                size={size}
                disabled={markAllLoading}
                variant={variant}
                startIcon={<TbChecks />}
            >
                Hepsini okundu olarak işaretle
            </Button>
        )) ||
        null
    );
}
export default NotificationHeader;
